import moment from "moment";
import { createSlice } from "@reduxjs/toolkit";

interface Filter {
    customers?: string[]
    startDate: string
    endDate: string
    isFiltered: boolean
}

interface FilterState {
    Filter: Filter
}

const initialState: FilterState = {
    Filter: {
        customers: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        isFiltered: false
    }
}

export const FilterSlice = createSlice({
    name: 'Filter',
    initialState,
    reducers: {
        setFilter: (state, action) => {
            state.Filter = action.payload
        },
    },
})

export const { setFilter } = FilterSlice.actions
